<template>
  <div :style="{ position: 'relative' }">
    <InputText
      :modelValue="displayValue"
      :disabled="disabled"
      readonly
      @click="toggle"
      class="w-full"
      style="cursor: 'pointer';"
    />

    <!-- Dropdown Panel -->
    <OverlayPanel ref="overlayPanel" :showCloseIcon="false" class="w-80" style="marginTop: -1px;">
      <div class="p-1">
        <div class="font-bold mb-3">Set Default Value</div>

        <!-- Radio Button Options -->
        <div class="flex flex-column gap-3">
          <div class="flex align-items-center">
            <RadioButton
              v-model="selectedOption"
              inputId="noDefault"
              name="defaultNumberType"
              value="none"
              @change="onRadioChange"
            />
            <label for="noDefault" class="ml-2">No Default</label>
          </div>

          <div class="flex align-items-center">
            <RadioButton
              v-model="selectedOption"
              inputId="specificValue"
              name="defaultNumberType"
              value="specific"
            />
            <label for="specificValue" class="ml-2">Choose a specific default value</label>
          </div>

          <!-- InputNumber appears when specific value is selected -->
          <div v-if="selectedOption === 'specific'" class="flex gap-2 align-items-center">
            <InputNumber
              v-model="specificValue"
              placeholder="Enter default value"
              class="w-full"
              :maxFractionDigits="10"
            />
            <Button label="OK" class="p-button-sm" @click="apply" />
          </div>
        </div>
      </div>
    </OverlayPanel>
  </div>
</template>

<script>
import InputText from 'primevue/inputtext'
import InputNumber from 'primevue/inputnumber'
import OverlayPanel from 'primevue/overlaypanel'
import RadioButton from 'primevue/radiobutton'
import Button from 'primevue/button'

export default {
  name: 'NumberDropdown',
  components: {
    InputText,
    InputNumber,
    OverlayPanel,
    RadioButton,
    Button
  },

  props: {
    modelValue: {
      type: String,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },

  emits: ['update:modelValue'],

  data() {
    return {
      selectedOption: 'none',
      specificValue: null
    }
  },

  computed: {
    displayValue() {
      if (this.modelValue === null || this.modelValue === undefined || this.modelValue === '') {
        return 'No Default';
      }
      return String(this.modelValue);
    }
  },

  watch: {
    modelValue: {
      handler() {
        this.initializeState()
      },
      immediate: true
    }
  },

  methods: {
    toggle(event) {
      if (!this.disabled) {
        this.$refs.overlayPanel.toggle(event)
        this.initializeState()
      }
    },

    initializeState() {
      if (this.modelValue === null || this.modelValue === undefined || this.modelValue === '') {
        this.selectedOption = 'none';
      } else {
        this.selectedOption = 'specific';
        const n = parseFloat(this.modelValue);
        this.specificValue = Number.isNaN(n) ? null : n;
      }
    },

    onRadioChange() {
      if (this.selectedOption !== 'specific') {
        this.apply()
      }
    },

    apply() {
      let newValue = null

      switch (this.selectedOption) {
        case 'none':
          newValue = null
          break
        case 'specific':
          newValue = this.specificValue != null ? String(this.specificValue) : null
          break
      }

      this.$emit('update:modelValue', newValue)
      this.$refs.overlayPanel.hide()
    }
  }
}
</script>
